import './plugin';

import PageView from './PageView/index';
import Layout from './Layout/index';
import Loading from './Loading/index';
import CountDown from './CountDown/index';

import Fticon from './FtIcon/index';
import GiveLike from './GiveLike/index';
import SpeakSheet from './SpeakSheet/index';
// import BubbleCard from './BubbleCard/index';

import Dynamic from './Dynamic/index';
import File from './File/index';
import Interact from './Interact/index';
import Introduction from './Introduction/index';
import Question from './Question/index';
import Review from './Review/index';
import Tabs from './Tabs/index';
import VideoHandle from './VideoHandle/index';

import Ad from './Ad/index';
import Barrage from './Barrage/index';
import MultiCamera from './MultiCamera/index';
import Player from './Player/index';
import VrPlayer from './VrPlayer/index';
import VideoPlayer from './VideoPlayer/index';
import CodeEnter from './CodeEnter/index';

import Footer from './Footer/index';
import Invite from './Invite/index';
import Suswindow from './Suswindow/index';
import Login from './Login/index';

import CommonIframe from './CommonIframe/index';
import LongTouch from './LongTouch/index';

const install = function install(Vue) {
  Vue.use(PageView);
  Vue.use(Dynamic);
  Vue.use(File);
  Vue.use(Interact);
  Vue.use(Introduction);
  Vue.use(Question);
  Vue.use(Review);
  Vue.use(Tabs);

  Vue.use(Layout);
  Vue.use(Loading);
  Vue.use(CountDown);
  Vue.use(Fticon);
  Vue.use(GiveLike);
  Vue.use(SpeakSheet);
  // Vue.use(BubbleCard);
  Vue.use(Ad);
  Vue.use(Barrage);
  Vue.use(Player);
  Vue.use(VrPlayer);
  Vue.use(MultiCamera);
  Vue.use(VideoPlayer);
  Vue.use(VideoHandle);
  Vue.use(CodeEnter);
  Vue.use(Footer);
  Vue.use(Invite);
  Vue.use(Suswindow);
  Vue.use(CommonIframe);
  Vue.use(LongTouch);

  Vue.use(Login);
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  version: '2.0.0',
  install
};
